function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, inject, toRef, ref, computed, openBlock, createElementBlock, normalizeClass, unref, createElementVNode, renderSlot, Fragment, renderList, toDisplayString, createCommentVNode, createVNode, withCtx } from 'vue';
import dayjs from 'dayjs';
import { ElIcon } from '../../../icon/index.mjs';
import '../../../../hooks/index.mjs';
import { DArrowLeft, DArrowRight } from '@element-plus/icons-vue';
import { panelMonthRangeProps, panelMonthRangeEmits } from '../props/panel-month-range.mjs';
import { useMonthRangeHeader } from '../composables/use-month-range-header.mjs';
import { useRangePicker } from '../composables/use-range-picker.mjs';
import MonthTable from './basic-month-table.mjs';
import _export_sfc from '../../../../_virtual/plugin-vue_export-helper.mjs';
import { useLocale } from '../../../../hooks/use-locale/index.mjs';
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["disabled"];
const _hoisted_3 = ["disabled"];
const unit = "year";
const __default__ = defineComponent({
  name: "DatePickerMonthRange"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: panelMonthRangeProps,
  emits: panelMonthRangeEmits,
  setup(__props, _ref) {
    let emit = _ref.emit;
    const props = __props;
    const _useLocale = useLocale(),
      lang = _useLocale.lang;
    const pickerBase = inject("EP_PICKER_BASE");
    const _pickerBase$props = pickerBase.props,
      shortcuts = _pickerBase$props.shortcuts,
      disabledDate = _pickerBase$props.disabledDate,
      format = _pickerBase$props.format;
    const defaultValue = toRef(pickerBase.props, "defaultValue");
    const leftDate = ref(dayjs().locale(lang.value));
    const rightDate = ref(dayjs().locale(lang.value).add(1, unit));
    const _useRangePicker = useRangePicker(props, {
        defaultValue,
        leftDate,
        rightDate,
        unit,
        onParsedValueChanged
      }),
      minDate = _useRangePicker.minDate,
      maxDate = _useRangePicker.maxDate,
      rangeState = _useRangePicker.rangeState,
      ppNs = _useRangePicker.ppNs,
      drpNs = _useRangePicker.drpNs,
      handleChangeRange = _useRangePicker.handleChangeRange,
      handleRangeConfirm = _useRangePicker.handleRangeConfirm,
      handleShortcutClick = _useRangePicker.handleShortcutClick,
      onSelect = _useRangePicker.onSelect;
    const hasShortcuts = computed(() => !!shortcuts.length);
    const _useMonthRangeHeader = useMonthRangeHeader({
        unlinkPanels: toRef(props, "unlinkPanels"),
        leftDate,
        rightDate
      }),
      leftPrevYear = _useMonthRangeHeader.leftPrevYear,
      rightNextYear = _useMonthRangeHeader.rightNextYear,
      leftNextYear = _useMonthRangeHeader.leftNextYear,
      rightPrevYear = _useMonthRangeHeader.rightPrevYear,
      leftLabel = _useMonthRangeHeader.leftLabel,
      rightLabel = _useMonthRangeHeader.rightLabel,
      leftYear = _useMonthRangeHeader.leftYear,
      rightYear = _useMonthRangeHeader.rightYear;
    const enableYearArrow = computed(() => {
      return props.unlinkPanels && rightYear.value > leftYear.value + 1;
    });
    const handleRangePick = function (val) {
      let close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      const minDate_ = val.minDate;
      const maxDate_ = val.maxDate;
      if (maxDate.value === maxDate_ && minDate.value === minDate_) {
        return;
      }
      emit("calendar-change", [minDate_.toDate(), maxDate_ && maxDate_.toDate()]);
      maxDate.value = maxDate_;
      minDate.value = minDate_;
      if (!close) return;
      handleRangeConfirm();
    };
    const formatToString = days => {
      return days.map(day => day.format(format));
    };
    function onParsedValueChanged(minDate2, maxDate2) {
      if (props.unlinkPanels && maxDate2) {
        const minDateYear = (minDate2 == null ? void 0 : minDate2.year()) || 0;
        const maxDateYear = maxDate2.year();
        rightDate.value = minDateYear === maxDateYear ? maxDate2.add(1, unit) : maxDate2;
      } else {
        rightDate.value = leftDate.value.add(1, unit);
      }
    }
    emit("set-picker-option", ["formatToString", formatToString]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([unref(ppNs).b(), unref(drpNs).b(), {
          "has-sidebar": Boolean(_ctx.$slots.sidebar) || unref(hasShortcuts)
        }])
      }, [createElementVNode("div", {
        class: normalizeClass(unref(ppNs).e("body-wrapper"))
      }, [renderSlot(_ctx.$slots, "sidebar", {
        class: normalizeClass(unref(ppNs).e("sidebar"))
      }), unref(hasShortcuts) ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(unref(ppNs).e("sidebar"))
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(unref(shortcuts), (shortcut, key) => {
        return openBlock(), createElementBlock("button", {
          key,
          type: "button",
          class: normalizeClass(unref(ppNs).e("shortcut")),
          onClick: $event => unref(handleShortcutClick)(shortcut)
        }, toDisplayString(shortcut.text), 11, _hoisted_1);
      }), 128))], 2)) : createCommentVNode("v-if", true), createElementVNode("div", {
        class: normalizeClass(unref(ppNs).e("body"))
      }, [createElementVNode("div", {
        class: normalizeClass([[unref(ppNs).e("content"), unref(drpNs).e("content")], "is-left"])
      }, [createElementVNode("div", {
        class: normalizeClass(unref(drpNs).e("header"))
      }, [createElementVNode("button", {
        type: "button",
        class: normalizeClass([unref(ppNs).e("icon-btn"), "d-arrow-left"]),
        onClick: _cache[0] || (_cache[0] = function () {
          return unref(leftPrevYear) && unref(leftPrevYear)(...arguments);
        })
      }, [createVNode(unref(ElIcon), null, {
        default: withCtx(() => [createVNode(unref(DArrowLeft))]),
        _: 1
      })], 2), _ctx.unlinkPanels ? (openBlock(), createElementBlock("button", {
        key: 0,
        type: "button",
        disabled: !unref(enableYearArrow),
        class: normalizeClass([[unref(ppNs).e("icon-btn"), {
          [unref(ppNs).is("disabled")]: !unref(enableYearArrow)
        }], "d-arrow-right"]),
        onClick: _cache[1] || (_cache[1] = function () {
          return unref(leftNextYear) && unref(leftNextYear)(...arguments);
        })
      }, [createVNode(unref(ElIcon), null, {
        default: withCtx(() => [createVNode(unref(DArrowRight))]),
        _: 1
      })], 10, _hoisted_2)) : createCommentVNode("v-if", true), createElementVNode("div", null, toDisplayString(unref(leftLabel)), 1)], 2), createVNode(MonthTable, {
        "selection-mode": "range",
        date: leftDate.value,
        "min-date": unref(minDate),
        "max-date": unref(maxDate),
        "range-state": unref(rangeState),
        "disabled-date": unref(disabledDate),
        onChangerange: unref(handleChangeRange),
        onPick: handleRangePick,
        onSelect: unref(onSelect)
      }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "onChangerange", "onSelect"])], 2), createElementVNode("div", {
        class: normalizeClass([[unref(ppNs).e("content"), unref(drpNs).e("content")], "is-right"])
      }, [createElementVNode("div", {
        class: normalizeClass(unref(drpNs).e("header"))
      }, [_ctx.unlinkPanels ? (openBlock(), createElementBlock("button", {
        key: 0,
        type: "button",
        disabled: !unref(enableYearArrow),
        class: normalizeClass([[unref(ppNs).e("icon-btn"), {
          "is-disabled": !unref(enableYearArrow)
        }], "d-arrow-left"]),
        onClick: _cache[2] || (_cache[2] = function () {
          return unref(rightPrevYear) && unref(rightPrevYear)(...arguments);
        })
      }, [createVNode(unref(ElIcon), null, {
        default: withCtx(() => [createVNode(unref(DArrowLeft))]),
        _: 1
      })], 10, _hoisted_3)) : createCommentVNode("v-if", true), createElementVNode("button", {
        type: "button",
        class: normalizeClass([unref(ppNs).e("icon-btn"), "d-arrow-right"]),
        onClick: _cache[3] || (_cache[3] = function () {
          return unref(rightNextYear) && unref(rightNextYear)(...arguments);
        })
      }, [createVNode(unref(ElIcon), null, {
        default: withCtx(() => [createVNode(unref(DArrowRight))]),
        _: 1
      })], 2), createElementVNode("div", null, toDisplayString(unref(rightLabel)), 1)], 2), createVNode(MonthTable, {
        "selection-mode": "range",
        date: rightDate.value,
        "min-date": unref(minDate),
        "max-date": unref(maxDate),
        "range-state": unref(rangeState),
        "disabled-date": unref(disabledDate),
        onChangerange: unref(handleChangeRange),
        onPick: handleRangePick,
        onSelect: unref(onSelect)
      }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "onChangerange", "onSelect"])], 2)], 2)], 2)], 2);
    };
  }
}));
var MonthRangePickPanel = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "panel-month-range.vue"]]);
export { MonthRangePickPanel as default };